import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function numbersAnimations() {
  document.addEventListener("DOMContentLoaded", () => {
    const numbers = document.querySelectorAll(".js-animate-number");
    if (!numbers.length) return;

    numbers.forEach((el) => {
      const finalValue = parseFloat(el.dataset.number) || 0;

      // reset iniziale
      gsap.set(el, { innerText: 0, opacity: 0 });

      gsap.to(el, {
        opacity: 1,
        duration: 0.8,
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          toggleActions: "play none none none",
          once: true
        },
        onStart: () => {
          gsap.to(el, {
            innerText: finalValue,
            duration: 2,
            ease: "power1.out",
            snap: { innerText: 1 }, // numeri interi
            modifiers: {
              innerText: (value) => `${Math.round(value)}%`
            }
          });
        }
      });
    });
  });
}